import React from 'react'
import { ArrowLeftIcon, Pane, Heading } from 'evergreen-ui'
import { withRouter } from 'react-router-dom'

const BackBar = props => {
  let back = async () => {
    props.history.push('/')
  }

  return (
    <Pane
      position={'sticky'}
      width={'100%'}
      top={0}
      padding={10}
      maxHeight={60}
      background={'#084b8a'}
      borderBottom={'1px solid rgb(228,231,235, 0.15)'}
      display={'flex'}
      flexDirection={'row'}
      alignItems={'center'}
      zIndex={1}
    >
      <ArrowLeftIcon 
        color="white"
        height={40} 
        onClick={props.back || back.bind(this)}
      />
      {props && props.title && (
        <Pane
          display={'flex'}
          flexDirection={'row'}
          justifyContent={'center'}
          alignItems={'center'}
          width="90%"
        >
          <Heading size={500} minWidth={68} color={'white'}>
            {props.title}
          </Heading>
        </Pane>
      )}{' '}
    </Pane>
  )
}

export default withRouter(BackBar)
